import React from 'react';
import { VerifierModel } from 'services/EpdClient';
import { EPDVerifierModel } from 'types/types';
import VerifierCompanyCard from './VerifierCompanyCard';
import styled from 'styled-components';

interface VerifierCompaniesListProps {
  epdVerifier: EPDVerifierModel | null;
  verifierCompanies: VerifierModel[];
  selectedVerifierCompany: VerifierModel | undefined;
  onSelectVerifierCompany: any;
  onAddVerifier: any;
  buttonsAreDisabled?: boolean;
}

const VerifierCompaniesList: React.FunctionComponent<VerifierCompaniesListProps> = ({
  epdVerifier,
  verifierCompanies,
  selectedVerifierCompany,
  onSelectVerifierCompany,
  onAddVerifier,
  buttonsAreDisabled,
}) => (
  <ListContainer>
    {verifierCompanies.map((company) => (
      <VerifierCompanyCard
        key={company.id}
        data={company}
        onSelectVerifier={() =>
          onSelectVerifierCompany((prev: VerifierModel | undefined) => (prev?.id === company.id ? undefined : company))
        }
        onAddVerifier={onAddVerifier}
        expanded={selectedVerifierCompany?.id === company.id}
        buttonsAreDisabled={
          company.id === epdVerifier?.companyId || company.information === epdVerifier?.companyName || buttonsAreDisabled
        }
      />
    ))}
  </ListContainer>
);

const ListContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
`;

export default VerifierCompaniesList;
